import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { ContentCopyExtension } from 'common/ContentCopyExtension/ContentCopyExtension';
import { TwoValueCellProps } from './TwoValueCell.interface';
import { pxToRem } from 'src/common/utils/fonts';

export const BoxTwoValueCell: React.FC<TwoValueCellProps> = ({
  primaryText,
  primaryVariant,
  primaryColor,
  secondaryText,
  secondaryVariant,
  secondaryColor,
  sx,
}) => {
  return (
    <Box
      sx={{
        verticalAlign: 'center',
        py: 6,
        ...sx,
      }}
      role="cell"
    >
      <Box sx={{ whiteSpace: 'nowrap', lineHeight: pxToRem(21) }} data-testid="primaryText">
        <ContentCopyExtension value={primaryText ?? ''}>
          <Typography variant={primaryVariant} color={primaryColor}>
            {primaryText ? primaryText : '-'}
          </Typography>
        </ContentCopyExtension>
      </Box>
      {secondaryText !== undefined && (
        <Box sx={{ whiteSpace: 'nowrap', lineHeight: pxToRem(18) }} data-testid="secondaryText">
          <ContentCopyExtension value={secondaryText ?? ''}>
            <Typography variant={secondaryVariant} color={secondaryColor}>
              {secondaryText === null || secondaryText === '' ? '-' : secondaryText}
            </Typography>
          </ContentCopyExtension>
        </Box>
      )}
    </Box>
  );
};
